import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JobTaskStatus } from '../../enum/job-task-status.enum';

@Pipe({
  name: 'jobTaskStatus'
})
export class JobTaskStatusPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(status: any, options?: string): any {
    if (!options) {
      switch (status) {
        case JobTaskStatus.STATUS_SCHEDULED:
          return 'scheduled';
        case JobTaskStatus.STATUS_IN_PROGRESS:
          return 'in-progress';
        case JobTaskStatus.STATUS_COMPLETED:
          return 'completed';
        case JobTaskStatus.STATUS_FAILED:
          return 'failed';
        case JobTaskStatus.STATUS_WARNING:
          return 'warning';
        case JobTaskStatus.STATUS_CANCELLED:
          return 'cancelled';
      }
    }

    if (options === 'tooltip') {
      switch (status) {
        case JobTaskStatus.STATUS_SCHEDULED:
          return this.translateService.instant('JOB_STATUS_SCHEDULED');
        case JobTaskStatus.STATUS_IN_PROGRESS:
          return this.translateService.instant('JOB_STATUS_IN_PROGRESS');
        case JobTaskStatus.STATUS_COMPLETED:
          return this.translateService.instant('JOB_STATUS_IN_COMPLETED');
        case JobTaskStatus.STATUS_FAILED:
          return this.translateService.instant('JOB_STATUS_IN_FAILED');
        case JobTaskStatus.STATUS_WARNING:
          return this.translateService.instant('JOB_STATUS_WARNING');
        case JobTaskStatus.STATUS_CANCELLED:
          return this.translateService.instant('JOB_STATUS_CANCELLED');
      }
    }
  }
}
